import React, { Component } from 'react';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';

export default class NoData extends Component {
  render() {
    return (
      <div className="page_margin30">
        <p>Уважаемый пользователь!</p>
        <p>Ваш личный кабинет формируется. Пожалуйста, попробуйте зайти позже.</p>
        <Link href={routeMap.login}>Вернуться к форме авторизации</Link>
      </div>
    );
  }
}
